import { forwardRef } from "react";
import { Command as CommandPrimitive } from "cmdk";

import {
  COMBOBOX_ITEM_INDICATOR_ICON,
  type TComboboxItemElement,
  type TComboboxItemProps,
} from "@/ui/components/form/Combobox/Combobox.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib/utils";

export const ComboboxItem = forwardRef<TComboboxItemElement, TComboboxItemProps>(
  (
    {
      children,
      className,
      icon,
      isSelected,
      ...props
    },
    ref,
  ) => (
    <CommandPrimitive.Item
      data-component="ComboboxItem"
      ref={ref}
      className={cn(
        "relative flex w-full cursor-default select-none items-center rounded-sys-sm py-1.5 pr-8 outline-none",
        icon ? "pl-8" : "pl-2",
        "aria-selected:bg-component-select-item-focused aria-selected:text-foreground-default",
        "data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50",
        className,
      )}
      {...props}
    >
      { icon ? (
        <span
          data-component="ComboboxItemIcon"
          className="absolute left-2 flex h-4 w-4 items-center justify-center"
        >
          <Icon
            icon={icon}
            aria-hidden="true"
            size="sm"
          />
        </span>
      ) : null }
      <span
        data-component="ComboboxItemIndicator"
        className={cn(
          "absolute right-2 flex h-4 w-4 items-center justify-center",
          !isSelected && "opacity-0",
        )}
      >
        <Icon
          icon={COMBOBOX_ITEM_INDICATOR_ICON}
          aria-hidden="true"
          size="sm"
        />
      </span>
      <TextBody
        tag="span"
        size={2}
        isResponsive={false}
        className="min-w-0 truncate"
      >
        { children }
      </TextBody>
    </CommandPrimitive.Item>
  ),
);

ComboboxItem.displayName = CommandPrimitive.Item.displayName;
